import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PayloadContext } from '../context';

const AuthRoute = ({ children, ...rest }) =>
{
	const { payload } = useContext(PayloadContext);

	return (
		<Route {...rest} render={() =>
		{
			return payload && payload !== null
				? children
				: <Redirect to={`/?redirect=${rest.location.pathname}${rest.location.search}`}/>;
		}
		}
		/>
	);
};

export default AuthRoute;